//API PATH
//dev
export const apiPath = process.env.REACT_APP_API_PATH;
//uat
// export const apiPath = 'https://dms-api.sec.gov.ph';
//prod
// export const apiPath = 'https://endow-api.sec.gov.ph'
